<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>

        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div>{{ answer[JsonFieldToDisplay()] }}</div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>

        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <b-form-select v-model="updatedAns" :disabled="answer && answer.isDisabled" size="sm" name="dropdown" class="fs-12 field-h40" style="width: 250px" :class="{ 'is-danger': hasFieldError }" @change="answerUpdated">
            <option v-for="(option, index) in question.options" :key="index" :value="option.id">
              {{ option.body }}
            </option>
          </b-form-select>
          <span v-if="hasFieldError" class="text-danger">
            <p>{{ fieldErrorText }}</p>
          </span>
          <span v-if="hasFieldWarning" class="text-warning">{{ fieldWarningText }}</span>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.answer_text : answer.display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>

            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.privius_answer_text : answer.privius_display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.privius_score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "DropdownResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: this.answer && this.answer.optionId,
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    usage: Object,
    stepIndex: Number,
    surveyData: Object,
    selectedLanguageCulture: String,
    activityType: String
  },
  mounted() {
    this.insertOtherOption();
  },
  watch: {
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    },
    updatedAns() {
      const selectedOption = this.question.options.filter(opt => opt.id == this.updatedAns)[0];
      if (this.answer && selectedOption) {
        this.answer.answerText = selectedOption.body;
        this.answer.optionId = selectedOption.id;
        this.answer.score = selectedOption.score;
        this.answer.computedScore = selectedOption.score;
      }
    }
  },
  methods: {
    answerUpdated() {
      this.checkForFieldErrors();
      this.$nextTick(() => {
        this.$emit(`answerChanged`, {
          questionId: this.question.id,
          newAns: this.answer.answerText
        });
      });

      if (this.answer.optionId == this.question.otherOptionId && this.question.otherCommentSelectedField && this.mode == 1) {
        this.$toastr.success(this.question.otherCommentSelectedField);
      }
    },
    checkForFieldErrors() {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK") {
              this.question.isSkippable = true;
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: `This field is required.`
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK") {
              this.question.isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
      if (!this.question.isSkippable && !!this.updatedAns == false) {
        this.hasFieldError = true;
        this.fieldErrorText = "This field is required.";
      } else if (this.question.isSkippable && !!this.updatedAns == false) {
        this.hasFieldWarning = true;
        this.fieldWarningText = "This field is required.";
      }
    },
    insertOtherOption() {
      if (this.question.otherOptionId) {
        const sequence = this.question.options.length + 1;
        this.question.options.push({
          addMessageEnabled: false,
          body: this.question.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: null
          },
          enabled: true,
          excludeScore: false,
          formattedBody: this.question.otherOptionContentField,
          id: this.question.otherOptionId,
          isAdvancedScoring: false,
          priority: 0,
          sendNotification: false,
          sequence: sequence
        });
      }
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}

.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>
